import { motion } from "framer-motion";
import { SOCIAL_STRIP } from "../data/site";
import { revealUp, viewportOnce } from "../lib/motion";

export const Social = () => {
  return (
    <section
      data-testid="social-section"
      className="overflow-hidden bg-offwhite py-20 sm:py-24"
    >
      <div className="mx-auto mb-10 max-w-[1400px] px-6 sm:px-10">
        <motion.h2
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          variants={revealUp}
          className="font-display text-2xl uppercase tracking-tight text-charcoal sm:text-3xl"
        >
          @CHICKENLABB_OFFICIAL
        </motion.h2>
      </div>

      <motion.div
        drag="x"
        dragConstraints={{ left: -700, right: 0 }}
        dragElastic={0.08}
        className="flex cursor-grab gap-4 px-6 active:cursor-grabbing sm:px-10"
        data-testid="social-strip"
      >
        {SOCIAL_STRIP.map((src, i) => (
          <div
            key={i}
            className="relative h-64 w-64 shrink-0 overflow-hidden rounded-[3px] bg-charcoal sm:h-80 sm:w-80"
          >
            <img
              src={src}
              alt={`Chicken Labb social ${i + 1}`}
              draggable={false}
              loading="lazy"
              decoding="async"
              className="pointer-events-none h-full w-full object-cover"
            />
          </div>
        ))}
      </motion.div>

      <div className="mx-auto mt-10 max-w-[1400px] px-6 sm:px-10">
        <a
          href="https://instagram.com"
          target="_blank"
          rel="noreferrer"
          data-testid="follow-social-link"
          className="font-display text-sm uppercase tracking-wider text-labred transition-colors hover:text-charcoal"
        >
          Follow on Instagram &amp; TikTok
        </a>
      </div>
    </section>
  );
};
